@@ -0,0 +1,78 @@
<template>
  <div>
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :rowActions="rowActions"
      :floatActions="floatActions"
      fileNamePrefix="rules_files"
      identifier="rules_files"
    ></pbas-data-table>
    <rules-file-dialog
      :model="dialogs.add"
      @close="dialogs.add = false"
      @save="addFile"
      :allGroups="memberGroups"
      :usedGroups="usedGroups"
      :ruleTypes="ruleTypes"
    />
    <rules-file-dialog
      :model="dialogs.edit"
      @save="updateFile"
      :value="selected"
      :file="selectedFile"
      :fileGroupLimit="selectedFileGroupLimit"
      @close="dialogs.edit = false"
      :allGroups="memberGroups"
      :usedGroups="usedGroups"
      :ruleTypes="ruleTypes"
    />
    <v-dialog scrollable v-model="dialogs.delete" persistent max-width="400">
      <material-card
        :title="$t('components.hoursbulktable.delete_title')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="deleteFile">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>
<script>
import { InMemoryProvider } from "pbas-vue-components";
import getHeaders from "@/headers/PlanBenefitRulesFiles";
import RulesFileDialog from "@/components/PlanBenefitsRules/RulesFileDialog.vue";
export default {
  components: {
    RulesFileDialog,
  },
  props: ["memberGroups", "ruleTypes"],
  data() {
    return {
      error: null,
      provider: undefined,
      dialogs: {
        edit: false,
        delete: false,
        add: false,
      },
      selected: null,
      selectedFile: null,
      selectedFileGroupLimit: null,
      deleteTitle: "",
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: "#64ba5f",
          text: "globals.add_new",
          handler: () => {
            this.dialogs.add = true;
          },
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.selected = JSON.parse(JSON.stringify(item));
            let f = this.files.filter(o=>o.Identifier === item.Identifier);
            if (f.length > 0) {
              this.selectedFile = f[0].File;
              this.selectedFileGroupLimit = f[0].FileGroupLimit;
            }
            this.dialogs.edit = true;
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.selected = item;
            this.dialogs.delete = true;
          },
        },
      ],
      files: [],
      items: [],
      usedGroups: []
    };
  },
  mounted() {
    this.provider = new InMemoryProvider(this.items, getHeaders());
  },
  watch:{
  },
  computed:{
  },
  methods: {
    computeGroups() {
      if (this.provider===null || this.provider === undefined) {
        return this.memberGroups;
      }
      if (this.provider.items===null || this.provider.items === undefined) {
        return this.memberGroups;
      }
      let used = this.provider.items.map(o=>{
        if (o.MemberGroups===null || o.MemberGroups === undefined) {
          return null;
        }
        return o.MemberGroups.map(oo=>oo.IdentityId)
      }).filter(o=>o!==null).flat();
      console.log(used);
      
      this.usedGroups = used;
    },
    addFile(payload) {
      console.log(payload);
      if (payload.item.noRules) {
        payload.item.File = undefined;
        payload.item.FileGroupLimit = undefined;
      } else {
        this.files.push({
          Identifier: payload.item.Identifier,
          File: payload.file,
          FileGroupLimit: payload.fileGroupLimit
        });
      }
      console.log(this.files);
      this.provider.items.push(payload.item);
      this.dialogs.add = false;
      this.$refs.table.getDataAsync();
      this.$emit("update", {items: this.provider.items, files: this.files});
      this.computeGroups();
    },
    updateFile(payload) {
      console.log(payload);
      const index = this.provider.items.findIndex(
        (o) => o.Identifier === payload.item.Identifier
      );
      this.provider.items[index] = payload.item;
      
      const fileIndex = this.files.findIndex(
        (o) => o.Identifier === payload.item.Identifier
      );
      console.log(fileIndex);
      if (payload.item.noRules) {
        if (fileIndex > -1) {
          this.files.splice(fileIndex, 1);
          this.provider.items[index].File = undefined;
          this.provider.items[index].FileGroupLimit = undefined;
        }
      } else {
        if (fileIndex === -1) {
          this.files.push({
            Identifier: payload.item.Identifier,
            File: payload.file,
            FileGroupLimit: payload.fileGroupLimit
          })
        } else {
          this.files[fileIndex] = {
            Identifier: payload.item.Identifier,
            File: payload.file,
            FileGroupLimit: payload.fileGroupLimit
          };
        }
      }
      
      console.log(this.files, this.provider.items);
      this.dialogs.edit = false;
      this.$refs.table.getDataAsync();
      this.$emit("update", {items: this.provider.items, files: this.files});
      this.computeGroups();
    },
    deleteFile() {
      console.log(this.provider.items, this.selected);
      this.provider.items = this.provider.items.filter(
        (o) => o.Identifier !== this.selected.Identifier
      );
      this.files = this.files.filter(
        (o) => o.Identifier !== this.selected.Identifier
      );
      this.dialogs.delete = false;
      this.$refs.table.getDataAsync();
      this.$emit("update", {items: this.provider.items, files: this.files});
      this.computeGroups();
    },
    // clear() {
    //   this.provider.items = [];
    //   this.files = [];
    //   this.$refs.table.getDataAsync();
    //   this.$emit("update", {items: this.provider.items, files: this.files});
    // }
  },
};
</script>
